import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import { Validators } from '@angular/forms';

import { NDDFormErrorService } from '../ndd-ng-form-error/shared/ndd-ng-form-error.service';
import { NDDFormsBaseComponent } from '../shared/ndd-ng-forms.base-component';

/** Componente checkbox. */
@Component({
    selector: 'ndd-ng-form-checkbox',
    template: require('./ndd-ng-form-checkbox.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NDDFormCheckboxComponent extends NDDFormsBaseComponent implements OnInit {
    /** Define se está marcado (checked). */
    @Input() public controlChecked: boolean;

    /** Evento de alteração da marcação (check). */
    @Output() public controlCheckedChange: EventEmitter<boolean> = new EventEmitter();

    constructor(
        formErrorService: NDDFormErrorService,
        cdr: ChangeDetectorRef,
    ) {
        super(formErrorService, cdr);
    }

    public ngOnInit(): void {
        super.addControl();

        if (this.controlRequired) {
            super.cacheValidator(Validators.requiredTrue);
        }

        super.addValidators();

        this.control.setValue(this.controlChecked);
    }

    public checked(): void {
        super.updateValidity();
    }

    public changed(value: any): void {
        this.controlChecked = value.target.checked;
        this.control.setValue(this.controlChecked);
        this.controlCheckedChange.emit(this.controlChecked);
    }
}
